import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { videosReducer } from "./videoReducers";
import {
  userLoginReducer,
  userAccountDetailsReducer,
  userPwdResetReducer,
  userLoggedinAndPremiumCheckReducer,
  userUnsubscribeMailReducer,
  userLocationReducer,
} from "./userReducers";
import { generalReducers, sendDailyMailTestReducer } from "./generalReducers";
import { paymentReducers } from "./paymentReducers";
import { blogsReducer } from "./blogReducers";
import { activitiesReducer } from "./activityReducers";
import { publicBlogsReducer } from "./publicBlogReducers";

export default combineReducers({
  form: formReducer,
  videos: videosReducer,
  userLogin: userLoginReducer,
  general: generalReducers,
  payment: paymentReducers,
  blogs: blogsReducer,
  userAccountDetails: userAccountDetailsReducer,
  userPwdReset: userPwdResetReducer,
  userLoggedinAndPremiumCheck: userLoggedinAndPremiumCheckReducer,
  userUnsubscribeMail: userUnsubscribeMailReducer,
  sendDailyMailTest: sendDailyMailTestReducer,
  activities: activitiesReducer,
  userLocation: userLocationReducer,
  publicBlogs: publicBlogsReducer,
});
